
define([], function() {
  return function(jqXHR) {
    return new Promise(function(resolve, reject) {
      jqXHR.done(function(result) {
        return resolve(result);
      });
      return jqXHR.error(function(error) {
        return reject(error);
      });
    });
  };
});
